import apiRequest from './client';

// Bloc "Avis" (centres de reparation + contact support + annonce). Lecture : company
// ou superadmin. Ecriture (PATCH) : superadmin uniquement.
export const getSiteNotice = () => apiRequest('/site-notice/');

export const updateSiteNotice = (data) =>
  apiRequest('/site-notice/', { method: 'PATCH', body: data });
